import QS from 'query-string'
import Bus from '../bus'
import { isObject } from 'lodash'

class ApiError extends Error {
  name = 'ApiError'

  constructor (message) {
    super(message)

    this.message = message
  }
}

// class ApiResponseError extends Error {
//   name = 'ApiResponseError'
//
//   constructor ({ response, data }) {
//     super(data.error)
//
//     this.response = response
//     this.data = data
//   }
// }

const DEFAULT_API_HOSTNAMES = {
  /*
    With process.env.NODE_ENV === 'production' should be

    cms: new URL('/cms/', window.location.origin),
    media: 'http://app4.front-server.purcellyoon.com',
    core: new URL('/api/', window.location.origin),

  */
  cms: null,
  media: null,
  core: null,
  ws: null,

  /*
    In production build we will use
    new URL('/ws/notifier2', `ws://${window.location.host}`)

    Currently using this cdn everywhere
  */
  cdn: 'http://d1fojj4wte942r.cloudfront.net'
}

/*
  TODO: Handle with oun errors (for next versions)

  class HttpError extends Error {
    name = 'HttpError'
  }

  class HttpAbortError extends Error {
    name = 'HttpAbortError'
  }
*/

class ApiManager {
  __apiHostnames = DEFAULT_API_HOSTNAMES
  __defaultHeaders = {}
  __authorizationToken = null

  setHostname = (apiName, baseUrl) => {
    this.__apiHostnames[apiName] = baseUrl
  }

  getHostname = (apiName) => {
    return this.__apiHostnames[apiName]
  }

  /*
    Method for setting additional api request headers
  */
  setDefaultHeaders = (defaultHeaders) => {
    if (isObject(defaultHeaders) && !Array.isArray(defaultHeaders)) {
      this.__defaultHeaders = defaultHeaders
    }
  }

  getDefaultHeaders = () => {
    return this.__defaultHeaders
  }

  setAuthorizationToken = (token) => {
    this.__authorizationToken = token
  }

  getAuthorizationToken = () => {
    return this.__authorizationToken
  }

  getWsProtocol () {
    return (window.location.protocol === 'https:')
      ? 'wss:'
      : 'ws:'
  }
}

const $api = new ApiManager()

export default $api

export const prepareRequest = requestOptions => {
  const {
    signal = null,
    api = 'core',
    method = 'GET',
    headers = {},
    token = $api.getAuthorizationToken(),
    query,
    url
  } = requestOptions

  if (!url) {
    throw new ApiError('no request options')
  }

  const options = {
    // redirect: 'follow',
    method: method,
    mode: 'cors',
    headers: {
      // Sending only json type data
      'Content-Type': 'application/json',
      // Expecting all json type data
      Accept: 'application/json',
      // Extra headers from api service
      ...$api.getDefaultHeaders(),
      // Extra headers from options
      ...headers
    },
    // Ref: https://developer.mozilla.org/en-US/docs/Web/API/AbortController/signal
    signal: signal
  }

  // Adding authorization token to the request header
  if (token) {
    options.headers.Authorization = `Bearer ${token}`
  }

  return async (data) => {
    const endpointURL = new URL(url, $api.getHostname(api))
    let href = endpointURL.href

    // Add search query to req URL
    if (query) {
      href += ('?' + QS.stringify(query))
    }

    if (data) {
      // Preparing request body based on content type
      if (options.headers['Content-Type'] === 'application/json') {
        options.body = JSON.stringify(data)
      } else {
        delete options.headers['Content-Type']
        options.body = data
      }
    }

    // Awaiting server data fetching
    const response = await fetch(href, options)

    // On HTTP 401 Unauthorized status
    if (response.status === 401) {
      /*
        Old implementation
        Removing registered auth tokens
        delete options.headers.Authorization
        // Refetching without authorization
        // Extra request attepmt
        response = await fetch(href, options)
      */

      $api.setAuthorizationToken(null)

      Bus.send({
        event: Bus.events.auth.unauthorized
      })
    }

    if (response.status === 204) return

    // Parsing json response data
    const jsonResponseData = await response.json()

    // For not successful results
    if (!response.ok) {
      if (response.status === 500) {
        /*
          Broadcasting Internal server error event
        */
        Bus.send({
          event: Bus.events.internal.error,
          data
        })
      }

      /*
        Request error logging
        logger.error('[api]', '☢️', 'error response ', data)
      */
      throw jsonResponseData
    }

    // Ok
    return jsonResponseData
  }
}
